import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { first } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import { AuthenticationService } from '../../../_services';
import { SharedService } from '../../../shared/_services/shared.service';
import { environment } from '../../../../environments/environment';
import {ApiService} from '../../../shared/_services/api.service';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.less']
})

export class EmailVerifyComponent implements OnInit {
  token: string;
  expires: string;
  signature: string;
  private sub: any;
  form: UntypedFormGroup;
  passwordVisible = false;

  public loading = false;
  public apiResponded = false;
  public msgType = '';
  public msgText = '';
  submitted = false;

  isCaptchaVerified = false;
  env = environment;

  constructor(
    private auth: AuthenticationService,
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private notification: NzNotificationService,
    private sharedService: SharedService,
  ) {
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      password: [null, [Validators.required, this.sharedService.passwordValidator]],
      passwordConfirmation: [null, [Validators.required]],
      captcha: [null, this.env.captcha ? [Validators.required] : []],
    }, {
      validators: this.sharedService.passwordConfirmationValidator
    });

    this.sub = this.route.params.subscribe(params => {
      this.token = params['token'];
    });

    this.route.queryParams.subscribe(params => {
      this.expires = params['expires'];
      this.signature = params['signature'];
    });
  }

  captchaResolved(isResolved: boolean): void {
    this.isCaptchaVerified = isResolved;
  }

  onSubmit() {
    this.submitted = true;

    this.loading = true;
    const payload = {
      password: this.f.password.value,
      passwordConfirmation: this.f.passwordConfirmation.value
    };

    this.api.verifyEmailSetPassword(payload, this.token, this.expires, this.signature).pipe(first()).subscribe(
      () => {
        this.notification.success('Success',
          'You have successfully verified your email address, you may log in now.');
        this.router.navigate(['/auth/login']);
      },
      () => {
        this.loading = false;
        this.submitted = false;
        this.notification.error('Error',
          'Something went wrong with the email verification process. You can try redoing the verification process by clicking on "Resend activation" link down below.');
      }
    );
  }

}
